export enum SOLD_SERVICES_CONTENT_MODE {
  ConvertLead,
  DuplicateOpp,
  EditOpp,
  NewOpp,
  CloneOpp,
}
